"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type AstroWeeklyMonthlyProps = {
    weeklyImage?: string;
    monthlyImage?: string;
    weeklySlug?: string;
    monthlySlug?: string;
    className?: string;
    imageMetadata?: ImageMetadata;
};

export default function astroweeklymonthly({
    weeklyImage = "https://media.dinamani.com/dinamani/2026-02-27/5u7t1tzo/weekly.png",
    monthlyImage = "https://media.dinamani.com/dinamani/2026-02-27/og31pqoi/monthly.png",
    weeklySlug = "astrology/astro-predictions/weekly-predictions",
    monthlySlug = "astrology/astro-predictions/monthly-predictions",
    className = "",
    imageMetadata,
}: AstroWeeklyMonthlyProps) {
    return (
        <section className={`bg-[#FFDB59] p-[43px] h-full p-b-[57px] ${className}`}>
            <div className="flex flex-col gap-[20px]">
                {/* Weekly Image */}
                <div className="relative w-full h-auto">
                    {weeklySlug ? (
                        <Link href={`/${weeklySlug}`} className="block hover:opacity-90 transition-opacity cursor-pointer">
                            <Image
                                src={weeklyImage}
                                alt="வார ராசிபலன்"
                                width={1200}
                                height={400}
                                className="w-full h-auto object-cover rounded-lg"
                                style={getFocusPointStyle(imageMetadata)}
                                loading="lazy"
                                placeholder="blur"
                                blurDataURL={BLUR_PLACEHOLDER}
                            />
                        </Link>
                    ) : (
                        <Image
                            src={weeklyImage}
                            alt="வார ராசிபலன்"
                            width={1200}
                            height={400}
                            className="w-full h-auto object-cover rounded-lg"
                            style={getFocusPointStyle(imageMetadata)}
                            loading="lazy"
                            placeholder="blur"
                            blurDataURL={BLUR_PLACEHOLDER}
                        />
                    )}
                </div>

                {/* Monthly Image */}
                <div className="relative w-full h-auto">
                    {monthlySlug ? (
                        <Link href={`/${monthlySlug}`} className="block hover:opacity-90 transition-opacity cursor-pointer">
                            <Image
                                src={monthlyImage}
                                alt="மாத ராசிபலன்"
                                width={1200}
                                height={400}
                                className="w-full h-auto object-cover rounded-lg"
                                style={getFocusPointStyle(imageMetadata)}
                                loading="lazy"
                                placeholder="blur"
                                blurDataURL={BLUR_PLACEHOLDER}
                            />
                        </Link>
                    ) : (
                        <Image
                            src={monthlyImage}
                            alt="மாத ராசிபலன்"
                            width={1200}
                            height={400}
                            className="w-full h-auto object-cover rounded-lg"
                            style={getFocusPointStyle(imageMetadata)}
                            loading="lazy"
                            placeholder="blur"
                            blurDataURL={BLUR_PLACEHOLDER}
                        />
                    )}
                </div>
            </div>
        </section>
    );
}
